/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SourceDestinationWeight = core.serialization.object({
    source: core.serialization.string(),
    destination: core.serialization.string(),
    weight: core.serialization.number(),
});
